import { registerPlugin } from '@capacitor/core';

/**
 * UserDefaults plugin reference. Registered once to avoid
 * "Capacitor plugin 'UserDefaults' already registered" warning.
 * Use getUserDefaultsPlugin() to get the same instance everywhere.
 */
let _userDefaultsPlugin: ReturnType<typeof registerPlugin<any>> | null = null;

export function getUserDefaultsPlugin(): ReturnType<typeof registerPlugin<any>> {
  if (_userDefaultsPlugin === null) {
    _userDefaultsPlugin = registerPlugin<any>('UserDefaults');
  }
  return _userDefaultsPlugin;
}
